import type * as THREE from "three";
import { fromObject } from "../ElementScene/ElementSceneConverter";
import type { IFileParser } from "./IFileParser";

class ElementSceneParser implements IFileParser {
	readonly supportedExtensions = ["json", "mesh"] as const;

	async parse(file: File): Promise<THREE.Object3D> {
		const text = await file.text();
		const data = JSON.parse(text);
		const result = fromObject(data);

		if (!result) {
			throw new Error(`Failed to parse mesh file: ${file.name}`);
		}

		result.name = result.name || file.name.split(".")[0] || "ElementScene_Model";

		return result;
	}
}

export { ElementSceneParser };
